import React from "react";

import { ArrowDown2 as ArrowDownIcon } from "iconsax-react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardTitle,
  CardContent,
} from "./styled";

interface CustomerPortalCardProps {
  children?: React.ReactNode;
  block?: boolean;
  fullHeight?: boolean;
  title?: string | React.ReactNode;
  isExandable?: boolean;
  justifyContent?: string;
}

export const CustomerPortalCard = (props: CustomerPortalCardProps) => {
  const { children, title, block, fullHeight, isExandable, justifyContent } = props;

  const renderTitle = () => {
    if (!title) return;

    return <CardTitle>{title}</CardTitle>;
  };

  if (isExandable) {
    return (
      <Accordion elevation={0} block={block} defaultExpanded disableGutters>
        <AccordionSummary
          expandIcon={<ArrowDownIcon size={20} />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {renderTitle()}
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    );
  }

  return (
    <Card elevation={0} block={block} fullHeight={fullHeight}>
      <CardContent fullHeight={fullHeight} justifyContent={justifyContent}>
        {renderTitle()}
        {children}
      </CardContent>
    </Card>
  );
};
